import * as React from 'react';
import TaskPane from './ui/components/TaskPane';
import { UsageLimitProvider, useUsageLimit } from './contexts/UsageLimitContext';
import { UsageLimitModal } from './ui/components/UsageLimitModal';
import { USAGE_LIMIT_EXCEEDED_EVENT, type UsageLimitErrorData } from './utils/usageLimitError';

function UsageLimitHandler(): null {
  const { showUsageLimitError } = useUsageLimit();

  React.useEffect(() => {
    const handleUsageLimitExceeded = (event: Event) => {
      showUsageLimitError((event as CustomEvent<UsageLimitErrorData>).detail);
    };

    window.addEventListener(USAGE_LIMIT_EXCEEDED_EVENT, handleUsageLimitExceeded);
    return () => {
      window.removeEventListener(USAGE_LIMIT_EXCEEDED_EVENT, handleUsageLimitExceeded);
    };
  }, [showUsageLimitError]);

  return null;
}

function UsageLimitModalWrapper(): React.ReactElement {
  const { showUsageLimitModal, usageLimitError, hideUsageLimitError } = useUsageLimit();

  return (
    <UsageLimitModal
      isOpen={showUsageLimitModal}
      onClose={hideUsageLimitError}
      errorData={usageLimitError}
    />
  );
}

const App: React.FC = () => {
  return (
    <UsageLimitProvider>
      <UsageLimitHandler />
      <TaskPane />
      <UsageLimitModalWrapper />
    </UsageLimitProvider>
  );
};

export default App;
